import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const GetProductCategoryAndKeywords = async _ref => {
  let {
    stargateBaseUrl
  } = _ref;
  const response = await fetchOk("".concat(stargateBaseUrl, "/marketplace/rest/1/product-tags"));
  return response.json();
};